export interface CampaignCopy {
	/** Top-Bar vor dem Trenner, mit dem Code. */
	bannerLead: string;
	/** Fester Endtext ohne Uhr; so rendert der Server, bis der Client zählt. */
	bannerEnds: string;
	/** Vorspann des Countdowns, gefolgt von der Restzeit. */
	bannerEndsIn: string;
	day: string;
	days: string;
	paymentRestriction: string;
}

export const CAMPAIGN_BANNER_SEPARATOR = " · ";

export function getCampaignCopy(
	campaign: { copy: Record<"de" | "en", CampaignCopy> },
	locale: string | null | undefined,
): CampaignCopy & { banner: string } {
	const copy = campaign.copy[locale === "de" ? "de" : "en"];
	return { ...copy, banner: `${copy.bannerLead}${CAMPAIGN_BANNER_SEPARATOR}${copy.bannerEnds}` };
}

/**
 * Restzeit als „1 Tag 13:59:10“ ab 24 Stunden, sonst „13:59:10“. Sekunden werden
 * aufgerundet, damit „00:00:00“ erst am Ende steht; negative Werte zählen als 0.
 */
export function formatCampaignCountdown(
	remainingMs: number,
	labels: Pick<CampaignCopy, "day" | "days">,
): string {
	const total = Math.max(0, Math.ceil(remainingMs / 1000));
	const days = Math.floor(total / 86_400);
	const pad = (value: number) => String(value).padStart(2, "0");
	const clock = `${pad(Math.floor((total % 86_400) / 3600))}:${pad(Math.floor((total % 3600) / 60))}:${pad(total % 60)}`;
	return days > 0 ? `${days} ${days === 1 ? labels.day : labels.days} ${clock}` : clock;
}
